export default "//yastatic.net/s3/distribution/pythia/frontend/_/4e720d19e39ab94e15f368ef0270dc96.jpeg";